function injectStyle (ssrContext) {
  require("!!vue-style-loader!css-loader?minimize!../../../node_modules/vue-loader/lib/style-compiler/index?{\"vue\":true,\"id\":\"data-v-9af4d2cc\",\"scoped\":true,\"hasInlineConfig\":false}!sass-loader!../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./splitter.vue")
}
var Component = require("!../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader?{\"babelrc\":false,\"presets\":[[\"@babel/preset-env\",{\"targets\":[\"> 1%\",\"iOS >= 8.0\",\"Android >= 4.4\",\"Chrome >= 30\",\"Safari >= 9\",\"Firefox ESR\",\"Opera 12.1\"]}]]}!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./splitter.vue"),
  /* template */
  require("!!../../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-9af4d2cc\",\"hasScoped\":true}!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./splitter.vue"),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-9af4d2cc",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/map/splitter.vue
// module id = 542
// module chunks = 0